var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"id":_vm.inputName,"placeholder":'Input: '+ _vm.inputName},domProps:{"value":_vm.inputValue},on:{"focus":_vm.onInputFocus,"input":_vm.onInputChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }